import styled from 'styled-components';
import { Button, Select, Text } from '@perch-labs/shrike';

export const StyledRequestButton = styled(Button).attrs({
  margin: { bottom: '16px', right: '32px', left: '32px' },
})``;

export const StyledCancelButton = styled(Button).attrs({
  backgroundless: true,
  margin: { bottom: '32px', right: '32px', left: '32px' },
})``;

export const StyledText = styled(Text).attrs({
  margin: { left: '32px', bottom: '24px', right: '32px', top: '16px' },
})``;

export const StyledSelect = styled(Select).attrs({
  margin: { bottom: '32px', right: '32px', left: '32px' },
})`
  width: 82%; // default to mobile

  @media (min-width: 768px) {
    // 768px is a common breakpoint for tablets and above
    width: 100%; // for desktop
  }
`;
